import { useBiLogger } from '../../../../../useBiLogger';
import React, { useContext } from 'react';
import { Box, Button, CloseButton, Text } from 'wix-style-react';
import ExternalLinkSmall from 'wix-ui-icons-common/ExternalLinkSmall';
import useRecCardCapsule from '../../../hooks/useRecCardCapsule';
import { FooterContext } from '../../../SideBarFooter';
import { sendBlockerOrRecCardActionsBi } from '../../../bi/bi.utils';
import { transformTitle } from '../helpers/actionCardBuilders';
export const RecCard = ({ actionObject }) => {
    const contextValues = useContext(FooterContext);
    const biLogger = useBiLogger();
    const { t, closePanel, appId, setShouldCheckDismissCount } = contextValues;
    const { title, navigateToTab, componentName, tabName } = actionObject;
    const { isDismissed, undoDismiss, dismissRec } = useRecCardCapsule({
        title,
        appId,
        setShouldCheckDismissCount,
    });
    const transformedTitle = transformTitle(title);
    const onGoToTabClick = () => {
        closePanel();
        navigateToTab();
    };
    return (React.createElement(React.Fragment, null, isDismissed ? (React.createElement(Box, { width: "363px", verticalAlign: "middle", borderBottom: "1px solid #DFE5EB", align: "space-between", paddingBottom: "18px", dataHook: `rec-card-dismissed-${title
            .replace(/_/g, '-')
            .toLowerCase()}` },
        React.createElement(Text, { size: "small", weight: "thin", dataHook: `rec-card-dismissed-title-${title
                .replace(/_/g, '-')
                .toLowerCase()}` }, t(`sg.action.card.title.${transformedTitle}`)),
        React.createElement(Button, { size: "tiny", onClick: () => {
                undoDismiss();
                sendBlockerOrRecCardActionsBi({
                    appId,
                    biLogger,
                    blockerOrRecCardActions: {
                        action_type: 'view',
                        tag_type: title,
                    },
                });
            }, priority: "secondary" }, t('sg.open.recommendation')))) : (React.createElement(Box, { borderRadius: "6px", padding: "18px", border: "1px solid", borderColor: "#DFE5EB", direction: "vertical", dataHook: `rec-card-${title.replace(/_/g, '-').toLowerCase()}` },
        React.createElement(Box, { direction: "horizontal", gap: "14px" },
            React.createElement(Box, { direction: "vertical", gap: "4px" },
                React.createElement(Text, { dataHook: `rec-card-title-${title
                        .replace(/_/g, '-')
                        .toLowerCase()}`, size: "small", weight: "bold", maxLines: 2, ellipsis: false }, t(`sg.action.card.title.${transformedTitle}`, {
                    componentName,
                })),
                React.createElement(Text, { secondary: true, size: "small", weight: "thin", maxLines: 3, ellipsis: false }, t(`sg.action.card.description.${transformedTitle}`, {
                    componentName,
                }))),
            React.createElement(Box, null,
                React.createElement(CloseButton, { dataHook: `rec-card-close-${title
                        .replace(/_/g, '-')
                        .toLowerCase()}`, onClick: () => {
                        dismissRec();
                        sendBlockerOrRecCardActionsBi({
                            appId,
                            biLogger,
                            blockerOrRecCardActions: {
                                action_type: 'dismiss',
                                tag_type: title,
                            },
                        });
                    }, skin: "dark", size: "medium" }))),
        React.createElement(Box, { gap: "small", verticalAlign: "middle", marginTop: "12px" },
            React.createElement(Button, { onClick: () => {
                    sendBlockerOrRecCardActionsBi({
                        appId,
                        biLogger,
                        blockerOrRecCardActions: {
                            action_type: 'learn-more',
                            tag_type: title,
                        },
                    });
                }, size: "tiny", as: "a", target: "_blank", dataHook: `rec-card-learn-more-button-${title
                    .replace(/_/g, '-')
                    .toLowerCase()}`, href: t(`sg.action.card.learn.more.link.${transformedTitle}`), suffixIcon: React.createElement(ExternalLinkSmall, null) }, t('learn.more')),
            title !== 'add.bi' && (React.createElement(Button, { onClick: () => {
                    onGoToTabClick();
                    sendBlockerOrRecCardActionsBi({
                        appId,
                        biLogger,
                        blockerOrRecCardActions: {
                            action_type: 'fix-rec',
                            tag_type: title,
                        },
                    });
                }, skin: "inverted", weight: "normal", size: "tiny", dataHook: `rec-card-go-to-page-button-${title
                    .replace(/_/g, '-')
                    .toLowerCase()}` }, `Go to ${tabName} Tab`)))))));
};
//# sourceMappingURL=RecCard.js.map